import { Svg, G, Path, Rect, Polygon } from '@react-pdf/renderer';

export const CheckboxSVG = () => (
  <Svg width="12" height="12" viewBox="0 0 512 512">
    <G fill="none" fillRule="evenodd">
      <G fill="#000000" transform="translate(64, 64)">
        <Path d="M384,0 L384,384 L0,384 L0,0 L384,0 Z M362.666667,21.3333333 L21.3333333,21.3333333 L21.3333333,362.666667 L362.666667,362.666667 L362.666667,21.3333333 Z" />
      </G>
    </G>
  </Svg>
);

export const CheckboxSelectedSVG = () => (
  <Svg width="12" height="12" viewBox="0 0 32 32" fill="#000000">
    <Path d="M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z" />
    <Polygon points="14 21.5 9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5" />
    <Rect width="32" height="32" fill="none" />
  </Svg>
);
